import store from "../store/index";
//--------------------
// get combatant slots (get all actions/reactions & markers for combatant)
//---------------------
export default async function getCombatantSlots(combatant_slug) {
  //
  return new Promise((resolve, reject) => {
    //--------------
    // access store
    //--------------
    const this_store = store;
    //--------------
    // set endpoint
    //--------------
    let endpoint = "api/v1/combatants/" + combatant_slug + "/slots/";
    //--------------------
    // set api call parms
    //--------------------
    let request = {
      method: "GET",
      endpoint: endpoint,
    };
    //--------------------------------
    // call combatant slots api (get)
    //--------------------------------
    this_store.dispatch("combat/viewCombatantSlots", request)
    .then((slots) => {
      console.log("IN COMBAT getCombatantSlots slots = ", slots.data.results[0]);
      let data = slots.data.results[0]
      resolve(data);
    })
    .catch((err) => {
      reject(err);
    });
  });
}
